'use strict';

import {Swiper} from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';

export function initSwiper() {
    const swiper = new Swiper('.swiper', {
        modules: [Navigation, Autoplay],
        slidesPerView: 1.25,
        spaceBetween: 14,

        breakpoints: {
            // ≥ 768px (tablet)
            320: {
                slidesPerView: 2.25,
                spaceBetween: 18,
            },
            // ≥ 1024px (desktop / velký monitor)
            1024: {
                slidesPerView: 3.25,
                spaceBetween: 24,
            },
        },
        navigation: {
            nextEl: ".instructors-next",
            prevEl: ".instructors-prev"
        },
        autoplay: { delay: 3000 },
    });

}